"use client";

import { useRouter } from "next/navigation";

type DeskBackButtonProps = {
  /** When `history.length` is 1 (e.g. direct open), navigate here instead of `router.back()`. */
  fallbackHref?: string;
  className?: string;
  label?: string;
};

/**
 * Browser-style back; falls back to `fallbackHref` when there is no prior history entry.
 */
export function DeskBackButton({
  fallbackHref = "/dashboard",
  className = "ed-desk-back-btn",
  label = "Back",
}: DeskBackButtonProps) {
  const router = useRouter();

  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        if (typeof window !== "undefined" && window.history.length > 1) {
          router.back();
        } else {
          router.push(fallbackHref);
        }
      }}
    >
      ← {label}
    </button>
  );
}
